import React, { Component } from "react";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

export class ProjectDates extends Component {
    render() {
        const {
            onChange,
            contractorSignatureDate,
            projectStartDate,
            finalDate,
            userType,
        } = this.props;
        return (
            <Card>
                <CardHeader title="Project Dates" className="romis-card-header" />
                <CardContent>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                            margin="normal"
                            variant="inline"
                            label="Contractor Signature Date :"
                            format="dd/MM/yyyy"
                            fullWidth

                            onChange={value => {
                                onChange("contractorSignatureDate", value);
                            }}
                            //value={
                            //  contractorSignatureDate === ""
                            //    ? new Date()
                            //    : contractorSignatureDate
                            //}
                            value={contractorSignatureDate}
                            name="contractorSignatureDate"
                            InputLabelProps={{
                                shrink: true
                            }}
                            autoOk

                            required={false}
                            disabled={userType !== 2 ? true : false}
                        />

                        <KeyboardDatePicker
                            margin="normal"
                            variant="inline"
                            label="Project Start Date :"
                            format="dd/MM/yyyy"
                            fullWidth
                            onChange={value => {
                                onChange("projectStartDate", value);
                            }}
                            //value={projectStartDate === "" ? new Date() : projectStartDate}
                            value={projectStartDate}
                            name="projectStartDate"
                            InputLabelProps={{
                                shrink: true
                            }}
                            autoOk
                            disabled={userType !== 2 ? true : false}
                        />
                        <KeyboardDatePicker
                            margin="normal"
                            variant="inline"
                            label="Final Date for Implementation :"
                            format="dd/MM/yyyy"
                            fullWidth
                            onChange={value => {
                                onChange("finalDate", value);
                            }}
                            //value={finalDate === "" ? new Date() : finalDate}
                            value={finalDate}
                            name="finalDate"
                            InputLabelProps={{
                                shrink: true
                            }}
                            autoOk
                            disabled={userType !== 2 ? true : false}
                        />
                    </MuiPickersUtilsProvider>
                </CardContent>
            </Card>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ProjectDates.js